import {
	cbsImg,
	cbsImg2,
	gyeongSangImg,
	infoLogoImg,
	jinjuImg,
	corpImg01,
	corpImg02,
	corpImg03,
	corpImg04,
	ad1,
	logo,
	notifyLogoImg,
	participateLogoImg,
	recogLogoImg,
	recordLogoImg,
} from './images';

// 폰트 사이즈(default 기준으로 제공이 되어짐)
export const defaultFontSize = 1;

export const fontSize = {
	xs: `${defaultFontSize * 0.75}rem`,
	sm: `${defaultFontSize * 0.875}rem`,
	sm2: `${defaultFontSize * 0.938}rem`,
	base: `${defaultFontSize * 1}rem`,
	lg: `${defaultFontSize * 1.125}rem`,
	xl: `${defaultFontSize * 1.25}rem`,
	xl2: `${defaultFontSize * 1.5}rem`,
	xl3: `${defaultFontSize * 1.75}rem`,
	xl4: `${defaultFontSize * 1.875}rem`,
	xl5: `${defaultFontSize * 2.25}rem`,
	xl6: `${defaultFontSize * 2.5}rem`,
	xl7: `${defaultFontSize * 2.75}rem`,
	xl8: `${defaultFontSize * 3}rem`,
	xl9: `${defaultFontSize * 3.75} rem`,
	xl10: `${defaultFontSize * 4.5} rem`,
	xl11: `${defaultFontSize * 6} rem`,
	xl12: `${defaultFontSize * 8} rem`,
};

export const fontWeight = {
	base: 400,
	normal: 400,
	medium: 500,
	semiBold: 600,
	bold: 700,
	extraBold: 800,
};

// 기본 베이스 width, height(default 기준으로 계산 되어짐) -> 폰트 변경되어지면 여기도 변경 필요
const buttonSize = {
	width: 16,
	height: 3.5,
};

export const defaultSize = {
	width: '',
	height: '2rem',
	margin: '0.25rem 0',
	buttonWidth: `${buttonSize.width} rem`,
	buttonHeight: `3.25rem`,
	minButtonWidth: `${buttonSize.width * 0.56} rem`,
	minButtonHeight: `2.5rem`,
	inputHeight: `3.25rem`,
	desktopContainer: '1194px',
	tabletContainer: '942px',
	mobileContainer: '90%',
	whiteCard: {
		desktop: '582px',
	},
	nav: {
		desktop: '85px',
		tablet: '70px',
		mobile: '70px',
	},
	li: {
		desktop: {
			titleHeight: '2rem',
			titleWidth: '7.75rem',
			titleLongWidth: '9.375rem',
		},
	},
	table: {
		desktop: {
			height: '4.25rem',
			width: 18.875,
		},
	},
};

// 컬러 수정
export const colorPalette = {
	primary: '#00903d',
	secondary: '#414f88',
	tertiary: '#25a3d2',
	lightBlack: '#303030',
	black: '#313131',
	white: 'white',
	realBlack: 'black',
	defaultBorder: '',
	label: '',
	invalid: '#ff0000',
	warn: '#f3e727',
	gray: '#e9e9e9',
	border: 'rgb(217, 217, 217)',
	noneBorder: '#707070',
	placeholder: '#cccccc',
	engTitle: '#8b8b8b',
	yeosumain: '#ffffff',
	neonbtn: '#e46e1c',
	// card: '#e6f4ff',
	card: '#22864fff',
	base: '#464646',
	thead: '#e46e1c',
	thText: '#ffffff',
	accent: '#f3e727',
	file: '#f2f2f2',
	divider: '#7b7b7b',
	boardBorder: '#d9d9d9',
	cardBorder: '#b2b2b2',
	// navColor: '#4d4d4d',
	navColor: '#ffffff',
	checkedRadio: 'rgba(59, 130, 246, 0.5)',
};

// 디스플레이 사이즈
export const viewSize = {
	mobile: '450px',
	tablet: '992px',
	desktop: '1920px',
};

// 필수 정보 리스트
export const requiredInfo = {
	name: {required: true},
	depositor: {required: true},
	phone: {required: true},
	phone1: {required: true},
	phone2: {required: true},
	phone3: {required: true},
	post_number: {required: true},
	address: {required: true},
	detail_address: {required: true},
	representative: {required: true},
	gender: {required: true},
	email: {required: false},
	birth: {required: true},
	year: {required: true},
	month: {required: true},
	day: {required: true},
	course: {required: true},
	gift: {required: true},
	group_name: {required: true},
	participated: {required: true},
	class_name: {required: false},
	school_name: {required: false},
	volunteer_id: {required: false},
	bib: {required: false},
};

// prod
export const TOKEN = '09d9bdce-5642-4249-bb29-0d927c157716';
// local
// export const TOKEN = 'd94f4edf-7af8-40b8-9a76-0f48f0dfc62f';

// API URL
export const API = 'http://43.201.64.16';
// export const API = 'http://127.0.0.1:8000';

export const defaultInfo = {
	mainTitle: '',
	date: '',
	bank: '',
	courseFee: '',
	accountHolder: '',
};

// 코스 설정
// export const courseList = ['풀코스', '하프코스', '10.19km코스', '5km코스'];
export const courseList = ['10.19km코스', '5km코스'];

// 코스별 기념품 매칭
export const giftMap = {
	// '풀코스': ['힙색'],
	// '하프코스': ['힙색'],
	// '10.19km코스': ['힙색'],
	// '5km코스': [
	// 	'티셔츠 - 80',
	// 	'티셔츠 - 85',
	// 	'티셔츠 - 90',
	// 	'티셔츠 - 95',
	// 	'티셔츠 - 100',
	// 	'티셔츠 - 105',
	// 	'티셔츠 - 110',
	// 	'티셔츠 - 115',
	// 	'티셔츠 - 120',
	// 	'티셔츠 - 125',
	// 	'티셔츠 - 130',
	// ],
	// '풀코스': [''],
	// '하프코스': [''],
	'10.19km코스': [''],
	'5km코스': [''],
};

// 기념품별 옵션 매칭
export const optionMap = {
	// '풀코스': [''],
	// '하프코스': [''],
	'10.19km코스': [''],
	'5km코스': [''],
	// '5km코스': [
	// 	'티셔츠 - 80',
	// 	'티셔츠 - 85',
	// 	'티셔츠 - 90',
	// 	'티셔츠 - 95',
	// 	'티셔츠 - 100',
	// 	'티셔츠 - 105',
	// 	'티셔츠 - 110',
	// 	'티셔츠 - 115',
	// 	'티셔츠 - 120',
	// 	'티셔츠 - 125',
	// 	'티셔츠 - 130',
	// ],
	// '티셔츠': [
	// 	'80',
	// 	'85',
	// 	'90',
	// 	'95',
	// 	'100',
	// 	'105',
	// 	'110',
	// 	'115',
	// 	'120',
	// ],
	// '기념품미정': [''],
};

// 봉사 신청 아이템
export const participatedList = [
	{date: '2025-10-18', weekday: '토'},
	{date: '2025-10-19', weekday: '일'},
	//{date: '2023-04-16', weekday: '일'},
	// {date: '2022-12-02', weekday: '화'},
	// {date: '2022-12-03', weekday: '수'},
];

// nav 설정
export const navProps = {
	logo: logo,
	links: [
		{name: '대회안내', key: 'info'},
		{name: '대회코스', key: 'course'},
		{name: '참가신청', key: 'participation'},
		{name: '대회기록', key: 'record'},
		{name: '참여마당', key: 'ground'},
	],
	button: {
		text: {
			children: '참가신청하기',
			fontSize: {
				desktop: fontSize.lg,
			},
			color: colorPalette.white,
			fontWeight: fontWeight.medium,
			fontFamily: 'Gmarket',
			// lineHeight: '2.6rem',
		},
		onClick: () =>
			(window.location.href = `${window.location.origin}/participation/person`),
		isRounded: true,
	},
	menus: [
		{
			title: '대회안내',
			menu: [
				{name: '대회요강', href: '/info/summary'},
				{name: '시상안내', href: '/info/award'},
				{name: '유의사항', href: '/info/note'},
				{name: '참가기념품', href: '/info/gift'},
				{name: '오시는길', href: '/info/direction'},
			],
		},
		{
			title: '대회코스',
			menu: [{name: '대회코스', href: '/course'}],
		},
		{
			title: '참가신청',
			menu: [
				{name: '개인참가신청', href: '/participation/person'},
				{name: '단체참가신청', href: '/participation/group'},
				{
					name: '개인참가신청 조회/수정',
					href: '/participation/person-update',
				},
				{
					name: '단체참가신청 조회/수정',
					href: '/participation/group-update',
				},
				{name: '자원봉사 신청', href: '/participation/volunteer'},
				{
					name: '자원봉사 신청 조회/수정',
					href: '/participation/volunteer-update',
				},
			],
		},
		{
			title: '대회기록',
			menu: [
				{name: '기록 조회', href: '/record/check'},
				// {name: '기록 업로드', href: '/record/boards'},
			],
		},
		{
			title: '참여마당',
			menu: [
				{name: '공지사항', href: '/ground/notify'},
				{name: '자유게시판', href: '/ground/free'},
				{name: '환불게시판', href: '/ground/refund'},
				{name: '대회사진', href: '/ground/picture'},
				// {name: '홍보게시판', href: '/ground/promotion'},
			],
		},
	],
};

const secondTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '26px',
		},
		color: colorPalette.secondary,
		fontWeight: fontWeight.medium,
	},
	content: {
		fontSize: {
			desktop: fontSize.base,
			tablet: '24px',
			mobile: '16px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.medium,
	},

	support: {
		width: '55px',
		height: '30px',

		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '15px',
		},
		color: colorPalette.primary,
		fontWeight: fontWeight.semiBold,
	},
};

// 아이콘 링크
export const mainLinks = [
	{
		img: {src: participateLogoImg},
		text: {
			...secondTextProps.content,
			children: '참가신청',
			fontFamily: 'Gmarket',
		},
		href: '/participation/person',
	},
	{
		img: {src: recogLogoImg},
		text: {
			...secondTextProps.content,
			children: '접수확인',
			fontFamily: 'Gmarket',
		},
		href: '/participation/person-update',
	},
	{
		img: {src: infoLogoImg},
		text: {
			...secondTextProps.content,
			children: '대회요강',
			fontFamily: 'Gmarket',
		},
		href: '/info/summary',
	},
	{
		img: {src: recordLogoImg},
		text: {
			...secondTextProps.content,
			children: '대회기록',
			fontFamily: 'Gmarket',
		},
		href: '/record/check',
	},
	{
		img: {src: notifyLogoImg},
		text: {
			...secondTextProps.content,
			children: '공지사항',
			fontFamily: 'Gmarket',
		},
		href: '/ground/notify',
	},
];

// 주최 후원
export const supporter = [
	{
		title: {
			...secondTextProps.support,
			children: '주최',
			color: colorPalette.white,
			fontWeight: fontWeight.bold,
		},
		text: {
			...secondTextProps.content,
			children: '10.19 평화마라톤 추진위원회',
		},
	},
	{
		title: {
			...secondTextProps.support,
			children: '주관',
			color: colorPalette.white,
			fontWeight: fontWeight.bold,
		},
		imgs: {
			desktop: [{src: ad1}],
			tablet: [{src: ad1}],
			mobile: [{src: ad1}],
		},
	},
];

export const footerProps = {
	name: '10.19평화마라톤',
	tel: '061-921-9900 ',
	fax: '061-921-9906',
};
